/**
 * Error thrown when the user wants to sign up with a postal code that has no delivery.
 */
export class NoDeliveryPostalCodeError extends Error {
    constructor(message: string) {
        super()
        this.name = "NoDeliveryPostalCodeError";
        this.message = message;
    }
}
